/* eslint-disable no-console */
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import ErrorPage from '../../pages/ErrorPage'

class ErrorBoundary extends React.Component {
  state = { hasRuntimeError: false }

  static getDerivedStateFromError() {
    return { hasRuntimeError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo)
  }

  render() {
    if (this.props.apiError || this.state.hasRuntimeError) {
      return <ErrorPage />
    }

    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  apiError: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
}

export default connect(state => ({ apiError: state.apiError }))(ErrorBoundary)
